'use client'

import Image from 'next/image'
import Button from '@/components/ui/Button'
import HeroDecorations from '@/components/ui/HeroDecorations'

export default function Hero() {
  return (
    <section className="relative min-h-[700px] md:min-h-[800px] overflow-hidden">
      {/* Çok katmanlı Gradient Arka Plan */}
      <div 
        className="absolute inset-0"
        style={{
          background: `
            linear-gradient(145deg, 
              #dbeafe 0%, 
              #eff6ff 20%, 
              #f0f9ff 40%, 
              #e0f2fe 60%, 
              #dbeafe 80%,
              #bfdbfe 100%
            )
          `,
        }}
      />
      
      {/* Radial gradient overlays */}
      <div 
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(ellipse at 20% 30%, rgba(59,130,246,0.18) 0%, transparent 50%),
            radial-gradient(ellipse at 80% 70%, rgba(96,165,250,0.15) 0%, transparent 50%),
            radial-gradient(ellipse at 50% 50%, rgba(147,197,253,0.1) 0%, transparent 60%)
          `,
        }}
      />
      
      {/* Dekoratif Elementler */}
      <HeroDecorations />
      
      {/* İçerik */}
      <div className="relative z-10 container-custom pt-28 pb-48 md:pt-40 md:pb-56">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/90 backdrop-blur-sm rounded-full border border-primary-200 shadow-lg shadow-primary-100/50 mb-8 animate-fade-in">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500"></span>
            </span>
            <span className="text-sm font-semibold text-primary-700">Türkiye Genelinde Aktif Hizmet</span>
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-gray-900 mb-8 leading-tight animate-fade-in">
            Hava Kalitesi İzlemede{' '}
            <span className="relative inline-block">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 via-primary-500 to-primary-600">
                Kesintisiz Teknoloji
              </span>
              <svg className="absolute -bottom-2 left-0 w-full h-3 text-primary-300" viewBox="0 0 200 12" preserveAspectRatio="none">
                <path d="M0,8 Q50,0 100,8 T200,8" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round"/>
              </svg>
            </span>
            <br className="hidden md:block" />
            <span className="text-gray-800">Güvenilir Veri</span>
          </h1>
          
          <p className="text-lg md:text-xl lg:text-2xl text-gray-600 mb-12 leading-relaxed animate-slide-up max-w-3xl mx-auto">
            Hava Kalitesi İzleme İstasyonları (HKİİ) işletimi, bakımı, kalibrasyonu ve laboratuvar sarf malzemeleri tedariğinde{' '}
            <strong className="text-gray-800 font-semibold">uzman çözüm ortağı</strong>.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-5 justify-center animate-scale-in">
            <Button 
              href="/hizmetler" 
              size="lg" 
              asLink 
              className="shadow-xl shadow-primary-500/30 hover:shadow-2xl hover:shadow-primary-500/40 hover:-translate-y-0.5 transition-all duration-300"
            >
              Hizmetlerimiz
            </Button>
            <Button 
              href="/iletisim" 
              variant="outline" 
              size="lg" 
              asLink 
              className="bg-white/70 backdrop-blur-sm hover:bg-white shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300"
            >
              İletişime Geçin
            </Button>
          </div>
          
          {/* İstatistikler */}
          <div className="mt-20 grid grid-cols-3 gap-6 md:gap-12 max-w-3xl mx-auto animate-slide-up">
            <div className="text-center p-4 md:p-6 bg-white/60 backdrop-blur-sm rounded-2xl border border-white/80 shadow-lg">
              <div className="text-3xl md:text-5xl font-bold text-primary-600 mb-1">27+</div>
              <div className="text-xs md:text-sm text-gray-600 font-medium">İstasyon</div>
            </div>
            <div className="text-center p-4 md:p-6 bg-white/60 backdrop-blur-sm rounded-2xl border border-white/80 shadow-lg">
              <div className="text-3xl md:text-5xl font-bold text-primary-600 mb-1">4</div>
              <div className="text-xs md:text-sm text-gray-600 font-medium">Bölge Müdürlüğü</div>
            </div>
            <div className="text-center p-4 md:p-6 bg-white/60 backdrop-blur-sm rounded-2xl border border-white/80 shadow-lg">
              <div className="text-3xl md:text-5xl font-bold text-primary-600 mb-1">%90+</div>
              <div className="text-xs md:text-sm text-gray-600 font-medium">Veri Verimliliği</div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Wave Divider - Profesyonel katmanlı dalga */}
      <div className="absolute bottom-0 left-0 right-0 w-full h-[180px] md:h-[220px]">
        <Image
          src="/images/decorations/wave-layered.svg"
          alt=""
          fill
          className="object-cover object-top"
          priority
        />
      </div>
    </section>
  )
}
